import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Modal from './Modal'

class ModalWrapper extends Component {
	state = {
		showModal: false
	}

	toggleModal = () => {
		this.setState({ showModal: !this.state.showModal }, () => {
			if(typeof this.props.modal.onClose === 'function' && !this.state.showModal) {
				this.props.modal.onClose()
			}
		})
	}

	render({ children, modal: { content, ...rest } } = this.props) {
		const modalContent = () => {
			if(!content) {
				return ''
			}

			const el = typeof content === 'function' ? content() : content
			return React.cloneElement(el, { closeModal: this.toggleModal })
		}

		return(
			<React.Fragment>
				{children(this.toggleModal)}
				{this.state.showModal &&
				<Modal {...rest} unmount={this.toggleModal}>
					{modalContent()}
				</Modal>}
			</React.Fragment>
		)
	}
}

ModalWrapper.propTypes = {
	children: PropTypes.func.isRequired,
	modal: PropTypes.shape({
		content: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
		onClose: PropTypes.func
	})
}

ModalWrapper.defaultProps = {
	modal: {}
}

export default ModalWrapper
